import { Component, Injectable } from "@angular/core";
import { SignalsMainComponent } from "./main.component";

@Component({
  selector: "app-signals-scheduled-create-edit",
  template: `<app-signals-message-create-edit
    [isScheduled]="true"
    title="Scheduled"
    location="scheduled"
  ></app-signals-message-create-edit>`,
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsScheduledCreateEditComponent extends SignalsMainComponent {}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsScheduledCreateEdit.component.ts